<template>

    <div class="button-toolbar" :class="classes">
        <slot></slot>
    </div>

</template>

<style scoped lang="scss">

    .button-toolbar {
        align-items: center;
        display: inline-flex;
        flex-shrink: 0;
        &.button-toolbar-vertical {
            flex-direction: column;
        }
        &.button-toolbar-spread {
            gap: 0;
            justify-content: space-evenly;
            width: 100%;
            > * {
                flex: 1;
            }
        }
        &.size-sm {
            gap: 5px;
        }
        &.size-md {
            gap: 10px;
        }
        &.size-lg {
            gap: 15px;
        }
    }

</style>

<script>

export default {

    props: {
        size: {
            type: String,
            default: 'sm',
        },
        spread: {
            type: Boolean,
            default: false,
        },
        vertical: {
            type: Boolean,
            default: false,
        },
    },

    computed: {

        classes() {
            return {
                'button-toolbar-spread': this.spread,
                'button-toolbar-vertical': this.vertical,
                'size-lg': this.size === 'lg',
                'size-md': this.size === 'md',
                'size-sm': this.size === 'sm',
            };
        },

    },

}

</script>
